import axios, { getData } from "lib/axios"

export const getInterviewers = async () => {
    return axios.get('recruitment/interviewers').then(getData)
}

export const createInterview = async (data) => {
    return axios.post(`recruitment/interviews`, data).then(getData)
}

// edit and cancel is the same endpoint
export const editInterview = async (id, data) => {
    return axios.put(`recruitment/interviews/${id}`, data).then(getData)
}

export const getInterview = async (id) => {
    return axios.get(`recruitment/interviews/${id}`).then(getData)
}

export const getEventList = async (year, month) => {
    return axios.get(`recruitment/interviews?year=${year}&month=${month}`).then(getData)
}

